import 'fg-frontend/third/highslide/highslide-full';

const hs = window.hs;

hs.graphicsDir = '/img/highslide/';
hs.transitions = ['expand', 'crossfade'];
hs.objectLoadTime = 'before'; // Load iframes 'before' or 'after' expansion.
hs.outlineType = '';
hs.align = 'center';
hs.dimmingOpacity = 0.7;

hs.cacheAjax = false;
hs.preserveContent = false;

// credits off
hs.showCredits = false;
hs.creditsHref = '';
hs.lang.creditsText = '';
hs.lang.creditsTitle = '';
hs.captionEval = 'this.a.title';
//hs.captionOverlay = { position  : 'above'};
//hs.marginRight = 85;
//hs.marginLeft = 85;
//hs.marginTop = 85;


/*if (hs.registerOverlay) {
	hs.registerOverlay({
		fade: 2,
		hideOnMouseOut: false,
		html: '<a href="javascript:" onclick="return hs.close(this)" class="closebutton pragueeu-hs-close">Zavřít</a>',
		useOnHtml: true,
		position: 'top right',
        relativeTo: 'viewport'
	});
}*/


hs.Expander.prototype.onBeforeExpand = function(sender) {

    //jen pro obrazky
    if (sender.a.className.indexOf("hs-htmlExpand") < 0) {

        // dynamicka navigace mezi fotkami

        var arrowLeft = document.createElement('div');
        var arrowRight = document.createElement('div');

        if (sender.getAdjacentAnchor(-1)) {
            arrowLeft.innerHTML = '<a href="javascript:" onclick="return hs.previous(this)" title="Předchozí" class="highslide-previous"><span class="glyphicon glyphicon-arrow-left"></span></a>';
            arrowLeft.className = "controlbar-arrows";
        }
        if (sender.getAdjacentAnchor(1)) {
            arrowRight.innerHTML = '<a href="javascript:" onclick="return hs.next(this)" title="Následující" class="highslide-next"><span class="glyphicon glyphicon-arrow-right"></span></a>';
            arrowRight.className = "controlbar-arrows";
        }
        if (arrowLeft.innerHTML != "") {
            sender.createOverlay({ overlayId: arrowLeft, position: "middle left", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2 });
        }
        if (arrowRight.innerHTML != "") {
            sender.createOverlay({ overlayId: arrowRight, position: "middle right", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2 });
        }
    }
};

/*hs.addEventListener(window, 'resize', function() {
    var expanders = hs.expanders,
        expandDuration = hs.expandDuration,
        restoreDuration = hs.restoreDuration,
        i = expanders.length,
        a,
        exp;

    console.log('res');
    var windowWidth = $(window).width() - $(window).width() / 10;
    var windowHeight = $(window).height() - $(window).height() / 10;

    console.log(windowWidth);
    console.log(windowHeight);

    //hs.width = windowWidth;
    //hs.height = windowHeight;

    // make it quick
    hs.expandDuration = 0;
    hs.restoreDuration = 0;

    while (i--) {
        exp = expanders[i];
        if (exp) {
            a = exp.a;
            exp.close();
            a.onclick();
        }
    }

    //console.log(a);

    // reset durations
    setTimeout(function() {
        hs.expandDuration = expandDuration;
        hs.restoreDuration = restoreDuration;
    }, expandDuration);

});*/

// settings for iframe popus for mobile devices
if (/(Android|BlackBerry|iPhone|iPad|iPod|Palm|Symbian)/.test(navigator.userAgent)) {

    // allow the height to exceed the viewport
    hs.allowHeightReduction = false;

    // remove the original settings
    var iframePopup = [];

    // add new settings
    var iframePopup = {
        objectType: 'iframe'
    };
}


// WEBPACK FOOTER //
// ./fe/web-default/src/js/highslide/highslide-settings.js